import { render, staticRenderFns } from "./DeliveryNoteView.vue?vue&type=template&id=21b739e8"
import script from "./DeliveryNoteView.vue?vue&type=script&lang=js"
export * from "./DeliveryNoteView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports